<template>
  <div>
    <div class="page-header">
      <h3 class="capitalize">{{tag_name}}</h3>
      <small v-if="hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Show Completed Tasks</small>
      <small v-if="!hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Hide Completed Tasks</small>
    </div>
    <TaskExpander />
    <NewQuickTask :selectedTags="[tag_name]"/>
    <ul class="mt-2 list-group">
      <li v-if="allTasks.length == 0" class="list-group-item">
        {{ $t("no_items") }}
      </li>
      <draggable v-else v-model="allTasks" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container">
            <QuickTask :task="task" :sortable=true />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander,
    draggable
  },
  data() {
    return {
      tag_slug: '',
      tag_name: '',
      hideComletedTasks: true
    };
  },
  computed: {
    allTasks: { 
      set: function(value){
        this.tag_slug = this.$route.params.tag_name
        this.tag_name = this.tag_slug.replace(/_/g, ' ');

        var ordered_ids = []
        value.forEach(function(item, index){
          ordered_ids.push(item.id)
        })

        var payload = {
          name: 'tagName' + this.tag_name,
          ordered_ids: ordered_ids
        }
        store.commit('updateSortedGroup', payload)

        return value;
      },
      get: function(){
        this.tag_slug = this.$route.params.tag_name
        this.tag_name = this.tag_slug.replace(/_/g, ' ');

        return store.getters.sortedTagTasks(this.$route.params.tag_name, this.hideComletedTasks)
      }
    }
  },
  methods: {
    toggleCompletedTasks(){
      this.hideComletedTasks = !this.hideComletedTasks
    }
  }
};
</script>
